import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription, Observable } from 'rxjs';
import { ActivatedRoute, Data, NavigationEnd, Router } from '@angular/router';
import { getInnermostChild } from '@uxdf/direct-shared-lib';
import { filter, map, switchMap } from 'rxjs/operators';

export interface TitleBarParams {
  title: string;
  subTitle: string;
}

@Injectable({
  providedIn: 'root'
})
export class TitleBarService implements OnDestroy {
  private readonly update$: BehaviorSubject<TitleBarParams>;
  private readonly subscriptions: Subscription;

  constructor(private readonly route: ActivatedRoute, private readonly router: Router) {
    this.update$ = new BehaviorSubject<TitleBarParams>({ title: '', subTitle: '' });
    this.subscriptions = new Subscription();
    this.subscriptions.add(
      this.getUpdates()
        .pipe(map(data => this.extractRouteData(data)))
        .subscribe(params => this.update$.next(params))
    );
  }

  public setTitle(key: string) {
    this.update$.next({ ...this.update$.value, title: key });
  }

  public setSubTitle(key: string) {
    this.update$.next({ ...this.update$.value, subTitle: key });
  }

  public getUpdate(): Observable<TitleBarParams> {
    return this.update$.asObservable();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  private getUpdates(): Observable<Data> {
    return this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      switchMap(() => getInnermostChild(this.route, 'firstChild').data)
    );
  }

  private extractRouteData(routeData: Data): TitleBarParams {
    return {
      title: routeData['titleBarFirstLine'] || this.update$.value.title,
      subTitle: routeData['titleBarSecondLine']
    };
  }
}
